import authAxios from "../common/authAxios";

class AdmissionInfoService {
  async getCombinedExams() {
    return await authAxios.get("/education/combined-exam/");
  }

  async getSelected() {
    return await authAxios.get("/admission-info/");
  }

  // * Академические степени
  async getAcademicDegrees() {
    return await authAxios.get("/education/academic-degree");
  }

  // * Группы ОП
  async getEducationalProgramGroups() {
    return await authAxios.get("/education/education-program-group");
  }
  // * ОП
  async getEducationalProgramById(eduId) {
    return await authAxios.get(`/education/get-by-id?id=${eduId}`);
  }

  // * Список ОП
  async getEducationalPrograms() {
    return await authAxios.get("/education/education-program");
  }

  async getAdditionalCourses() {
    return await authAxios.get("dictionaries/additional-course");
  }

  async getFinancingPrograms() {
    return await authAxios.get("dictionaries/financing-program");
  }
  // * Список ОП из DU
  async getDuEducationalPrograms(degreeId) {
    return await authAxios.get(
      `/dictionaries/get-du-education-programs?degreeId=${degreeId}`
    );
  }
  async getFinancingSources(financingId) {
    return await authAxios.get(`/dictionaries/financing-source?financingId=${financingId}`);
  }

  // * получить ГОП по DuEducationId
  async getEducationalProgramGroupByDuId(duId) {
    return await authAxios.get(
      `/education/get-education-program-group-by-duid?duId=${duId}`
    );
  }

  // * Виды экзаменов
  async getExamTypes() {
    return await authAxios.get("/education/exam-type");
  }

  async getExamLanguages() {
    return await authAxios.get("/education/exam-language");
  }

  async getQuota() {
    return await authAxios.get("/education/quota");
  }

  // * Типы экзаменов для подтверждения знаний английского языка
  async getEnglishCertificateTypes() {
    return await authAxios.get("/education/english-certificate-type");
  }

  async getOlympiadCertificateTypes() {
    return await authAxios.get("/education/olympiad-certificate-type");
  }

  async postAdmissionInfo(data) {
    return await authAxios.post("/admission-info/save-admission-info", data);
  }
}

export default AdmissionInfoService;
